// Mixpanel配置文件
export const mixpanelConfig = {
  // 请替换为你的Mixpanel项目token（EU数据中心）
  projectToken: 'fb298a5b5536fc4aecf6f2c7542d62a2', // 如果创建了新的EU项目，请替换为新Token
  
  // 配置选项
  options: {
    debug: process.env.NODE_ENV === 'development', // 仅在开发环境开启debug
    persistence: 'localStorage',
    
    // 生产环境使用批量发送优化性能，开发环境立即发送便于调试
    batch_requests: process.env.NODE_ENV === 'production',
    batch_size: 50,
    batch_flush_interval_ms: 5000,
    
    // 使用欧洲服务器（EU Data Residency）
    api_host: 'https://api-eu.mixpanel.com',
    
    // 忽略DNS错误
    ignore_dnt: true,
    
    // 确保跨子域名共享用户ID
    cross_subdomain_cookie: true,
    
    // 持久化distinct_id
    persistence_name: 'mixpanel'
  }
};

// 事件名称常量
export const MIXPANEL_EVENTS = {
  USER_LOGIN: 'User Login',
  USER_AUTO_LOGIN: 'User Auto Login',
  PAGE_VIEW: 'Page View'  // 页面浏览事件由router统一追踪
};

// 用户属性常量
export const MIXPANEL_USER_PROPERTIES = {
  NAME: '$name',              // Mixpanel标准属性：用户名称
  AVATAR: '$avatar',          // Mixpanel标准属性：用户头像
  DISTINCT_ID: '$distinct_id', // Mixpanel标准属性：用户唯一标识
  UNIONID: 'unionid',         // 微信UnionID
  OPENID: 'openid'            // 微信OpenID
};
